'use client';

import { ThemeProvider } from 'next-themes';
import { WebSocketProvider } from '@/shared/api/websocket';
import { StoreInitializer } from './store-initializer';
import { QueryProvider } from '@/app/providers/query-provider';
import { PreferencesProvider } from '@/shared/ui/components/PreferencesProvider';
import { ErrorBoundary } from '@/app/providers/error-boundary';
import { ForceUpdateModal } from '@/shared/ui/ForceUpdateModal';
import { LimitPaywallDialog } from '@/features/subscription/ui/LimitPaywallDialog';
import { PassPaywallDialog } from '@/features/subscription/ui/PassPaywallDialog';
import { Toaster } from '@/shared/ui/shadcn/sonner';
import { AppRouterBridge } from '@/shared/lib/app-router';

export function Providers({ children }: { children: React.ReactNode }) {
  // All state management handled by Zustand stores
  // ErrorBoundary wraps all providers to catch any render errors
  return (
    <ErrorBoundary>
      <ThemeProvider
        attribute="class"
        defaultTheme="system"
        enableSystem={true}
        disableTransitionOnChange={false}
        storageKey="getfacade-theme"
      >
        <QueryProvider>
          <PreferencesProvider>
            <WebSocketProvider>
              <AppRouterBridge />
              <StoreInitializer />
              {children}
              <ForceUpdateModal />
              <LimitPaywallDialog />
              <PassPaywallDialog />
            </WebSocketProvider>
            <Toaster position="top-right" richColors closeButton />
          </PreferencesProvider>
        </QueryProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}
